module.exports = __webpack_public_path__ + "img/logo.15ecd51b.jpg";